<i18n>
{
  "en": {
    "giftCard": "GIFT CARD",
    "giftCardMobile": "Gift Card"
  },
  "th": {
    "giftCard": "บัตรของขวัญ",
    "giftCardMobile": "บัตรของขวัญ"
  }
}
</i18n>

<script>
import localeMixin from "lib/localeMixin";
import NavbarChangeLang from "./NavbarChangeLang";

export default {
  name: "NavbarComponent",
  // app/concepts/navbar_cpt/view/user.erb
  template: "#navbar-component",
  components: {
    contactSupport: () => import("./ContactSupport.vue")
  },
  data() {
    return {
      query: "",
      isSearchBoxOpen: false,
      dropdownProfileOpen: false,
      dropdownOpen: false,
      isLoading: true,
      userName: ""
    };
  },
  computed: {
    langBtnIcon() {
      let icon = null;
      if (window.appConfig.locale === "th") {
        icon = "/img/change_lang_en.png?7a";
      } else if (window.appConfig.locale === "en") {
        icon = "/img/change_lang_th.png?7a";
      }
      return icon;
    }
  },
  mounted() {
    this.getUserName();
  },
  mixins: [localeMixin],
  methods: {
    onOver() {
      this.dropdownOpen = true;
    },
    onLeave() {
      this.dropdownOpen = false;
    },
    getUserName() {
      const { appConfig } = window
      const { signedInUser } = appConfig
      if (signedInUser) {
        this.userName = window.appConfig.signedInUser.Name;
      }
    },
    submitSearchForm(e) {
      window.location = `/${window.appConfig.locale}/restaurants/search?name=${this.query}`;
    },
    goPreviousPage() {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = "/";
      }
    },
    toggleNavbar() {
      const hiddenNavbarNode = this.$jq("#hidden-navbar");
      hiddenNavbarNode.slideToggle(700);
    },
    targetLang() {
      let locale = null;
      switch (window.appConfig.locale) {
        case "th":
          locale = "en";
          break;
        case "en":
          locale = "th";
          break;
        default:
          locale = "en";
          break;
      }
      return locale;
    },
    changeLang(lang) {
      let requestedLang;
      if (typeof lang === "string") {
        requestedLang = lang;
      } else {
        requestedLang = this.targetLang();
      }
      window.location.href = NavbarChangeLang(
        requestedLang,
        window.location.href
      );
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~styles/abstract/mixins";
@import "~styles/abstract/variables";

.nav {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}
.nav-tag {
  background-color: rgba(255, 80, 90, 1);
  color: white;
  padding: 2px 6px;
  font-size: 11px;
  &.desktop {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.hamburger-icon {
  width: 20px;
  height: 20px;
}
.logo {
  width: 130px;
  img {
    @include respond(max-mobile) {
      width: 90px;
    }
  }
}

.dropdown-burger {
  top: 42px;
  visibility: hidden;
  &.dropdownOpen {
    visibility: visible;
  }
}

.dropdown-profile {
  top: 42px;
  visibility: hidden;
  &.dropdownProfileOpen {
    visibility: visible;
  }
}

.searchbox {
  position: relative;
  min-width: 30px;
  width: 0%;
  height: 30px;
  overflow: hidden;
  transition: width 0.3s;
  border-radius: 25px;
  display: inline-flex;
}
.searchbox-input {
  top: 0;
  right: 0;
  border: 0;
  outline: 0;
  background: #f1f1f1;
  width: 100%;
  height: 30px;
  margin: 0;
  padding: 0px 40px 0px 20px;
  /* font-size: 20px; */
  color: red;
  border-radius: 25px;
}
.searchbox-input::-webkit-input-placeholder {
  color: #f15b5d;
}
.searchbox-input:-moz-placeholder {
  color: #f15b5d;
}
.searchbox-input::-moz-placeholder {
  color: #f15b5d;
}
.searchbox-input:-ms-input-placeholder {
  color: #f15b5d;
}

.searchbox-icon,
.searchbox-submit {
  width: 30px;
  height: 30px;
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
  margin: 0;
  border: 0;
  outline: 0;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  color: #ffffff;
}

.searchbox-open {
  width: 400px;
  @include respond(max-mobile) {
    width: 155px;
  }
}
.icon-search:before {
  @include respond(max-mobile) {
    display: inline-block !important;
    color: white;
  }
}
</style>
<i18n>
{
  "en": {
    "search": "Restaurant Name, Cuisine, Location"
  },
  "th": {
    "search": "ชื่อร้านอาหาร, ประเภท, สถานที่"
  }
}
</i18n>